<template>
  <div class="star-rating-wrapper">
    <div
      id="star-rating-caption"
      class="star-rating-wrapper__caption"
    >
      {{ displayCaption }}
    </div>
    <div
      class="star-rating-wrapper__stars"
      role="radiogroup"
      aria-labelledby="star-rating-caption"
    >
      <button
        v-for="star in 5"
        :key="star"
        type="button"
        role="radio"
        class="star-rating-wrapper__star"
        :data-cy="`star-${star}`"
        :class="{ 'star-rating-wrapper__star--filled': star <= (hovered || value) }"
        :aria-checked="value === star ? 'true' : 'false'"
        :aria-label="`${star} star${star > 1 ? 's' : ''} - ${captionFor(star)}`"
        @mouseenter="hovered = star"
        @mouseleave="hovered = 0"
        @focus="hovered = star"
        @blur="hovered = 0"
        @click="select(star)"
        @keydown="onKeydown($event, star)"
      >
        &#9733;
      </button>
    </div>
  </div>
</template>

<script>
import { STAR_CAPTIONS, STAR_CAPTION_DEFAULT } from '@/constants'

export default {
  name: 'StarRating',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      hovered: 0
    }
  },
  computed: {
    displayCaption () {
      if (this.hovered > 0) return STAR_CAPTIONS[this.hovered]
      if (this.value > 0) return STAR_CAPTIONS[this.value]
      return STAR_CAPTION_DEFAULT
    }
  },
  methods: {
    captionFor (star) {
      return STAR_CAPTIONS[star]
    },
    select (star) {
      this.$emit('input', star)
    },
    onKeydown (event, star) {
      let next = null
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
        event.preventDefault()
        next = Math.min(5, star + 1)
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
        event.preventDefault()
        next = Math.max(1, star - 1)
      }
      if (next == null) return
      this.select(next)
      this.$nextTick(() => {
        const stars = this.$el.querySelectorAll('[role="radio"]')
        const target = stars[next - 1]
        if (target && target.focus) target.focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.star-rating-wrapper {
  margin: 10px 0;

  &__caption {
    color: $text-primary;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -.02em;
    line-height: 20px;
    margin-bottom: 8px;
  }

  &__stars {
    display: flex;
    gap: 4px;
  }

  &__star {
    background: none;
    border: none;
    color: #ccc;
    cursor: pointer;
    font-size: 36px;
    line-height: 1;
    padding: 2px;
    transition: color .1s;

    &:focus {
      outline: 2px solid $text-primary;
      outline-offset: 2px;
    }

    &--filled {
      color: #f5a623;
    }
  }
}
</style>
